import { IonIcon } from '@ionic/react';
import { star } from 'ionicons/icons';
import { HStack, Spacer, VStack } from 'reaction';
import './LinkedInSkill.css';

export interface LinkedInSkillProps {
    skill: string;
    assessment?: boolean;
    children?: JSX.Element | JSX.Element[];
}

export interface SkillEndorsementProps {
    name: string;
    highlySkilled?: boolean;
    occupation: string;
    organization: string;
}

export default function LinkedInSkill({ skill, assessment, children }: LinkedInSkillProps) {
    function getEndorsementCount() {
        if (children) {
            if (Array.isArray(children)) return `${children.length} endorsements`;
            return '1 endorsement';
        }
        return '';
    }

    function Endorsements() {
        const count = getEndorsementCount();

        if (count) {
            return (
                <>
                    <small>{getEndorsementCount()}</small>

                    <h4 className='endorsed-by-title'>Endorsed by</h4>
                    {children}
                </>
            );
        }
        return null;
    }

    return (
        <VStack justify='start' align='start' height='auto' className='linkedin-skill'>
            <h3 className='skill-name'>{skill}</h3>
            <Spacer />
            {assessment && <small>Passed LinkedIn Skill Assessment</small>}
            <Endorsements />
        </VStack>
    );
}

export function SkillEndorsement({
    name,
    highlySkilled,
    occupation,
    organization,
}: SkillEndorsementProps) {
    return (
        <HStack justify='start' className='endorsement'>
            <h5 className='name'>{name}</h5>
            <small className='employment'>
                {occupation} at {organization}
            </small>
            <Spacer />
            {highlySkilled && (
                <small>
                    <IonIcon icon={star} /> Highly Skilled
                </small>
            )}
        </HStack>
    );
}
